import { html, nothing } from "lit";

export type FleetChatPanelId =
  | "orchestration"
  | "activity"
  | "subagents"
  | "sessionInspector"
  | "fleetSessions"
  | "environment"
  | "roster"
  | "fleetChecklist"
  | "projects"
  | "workspace"
  | "setup"
  | "conversation";

export type FleetChatPanelsCollapsed = Record<FleetChatPanelId, boolean>;

export const DEFAULT_FLEET_CHAT_PANELS_COLLAPSED: FleetChatPanelsCollapsed = {
  orchestration: false,
  activity: false,
  subagents: false,
  sessionInspector: false,
  fleetSessions: false,
  environment: false,
  roster: true,
  fleetChecklist: true,
  projects: false,
  workspace: false,
  setup: true,
  conversation: false,
};

export type FleetCollapsibleSectionProps = {
  title: string;
  /** Short line under the title (visible in the header). */
  description?: string;
  meta?: string;
  open: boolean;
  onToggle: () => void;
  bodyClass?: string;
  toggleTitle?: string;
};

/** Shared Fleet Control section chrome (show/hide + fleet theme). */
export function renderFleetCollapsibleSection(
  props: FleetCollapsibleSectionProps,
  body: unknown = nothing,
) {
  return html`
    <section
      class="fleet-section ${props.open ? "fleet-section--open" : ""}"
      aria-label=${props.title}
    >
      <button
        type="button"
        class="fleet-section__toggle"
        aria-expanded=${props.open}
        title=${props.toggleTitle ?? props.description ?? props.title}
        @click=${props.onToggle}
      >
        <span class="fleet-section__heading">
          <span class="fleet-section__title">${props.title}</span>
          ${
            props.description
              ? html`<span class="fleet-section__desc muted">${props.description}</span>`
              : nothing
          }
        </span>
        ${props.meta ? html`<span class="fleet-section__meta muted">${props.meta}</span>` : nothing}
        <span class="fleet-section__chevron" aria-hidden="true">${props.open ? "▼" : "▶"}</span>
      </button>
      ${
        props.open
          ? html`
            <div class="fleet-section__body ${props.bodyClass ?? ""}">
              ${body}
            </div>
          `
          : nothing
      }
    </section>
  `;
}
